import React, {useEffect, useState, useRef} from "react";
// import {
//     Box,
//     VStack,
//     Button,
//     Input,
//     FormControl,
//     FormErrorMessage,
//     useColorModeValue,
//     chakra, Container, useToast, List, ListItem, ListIcon, Text
// } from "@chakra-ui/react";

import {
    Box,
    List,
    ListItem,
    ListIcon,
    Button,
    VStack,
    Text,
    Input,
    chakra,
    FormControl,
    FormErrorMessage,
    useToast,
    Container,
    Circle,
    HStack,
    useColorModeValue,
    useBreakpointValue, FormLabel, FormHelperText, Link
} from "@chakra-ui/react";

import { CheckCircleIcon } from "@chakra-ui/icons";

import { Header as Nav } from "../header/Header";
import { Footer } from "../footer/Footer";
import { FormLabelEvo } from "../forms/chakra/label/FormLabelEvo";

import {fieldNameAndLabels, emptyFormDataCodeActivation, PAYMENT_CODE} from "../../infrastructure/utils/formUtils";
import {useNavigate} from "react-router-dom";
import {useEvoContext} from "../../context/evo.context";
import formValidator from "../forms/validate/validate";
import getFormValues from "../forms/values/formValues";
import SubscriptionCodeValidateDataProvider from "../dataProviderEvo/subscription-code-validate-data-provider";
import UserEmailCheckDataProvider from "../dataProviderEvo/user-email-check-data-provider";
import {FormControlEvo} from "../forms/chakra/FormControlEvo";
import {
    ROUTE_CODE_ACTIVATION,
    ROUTE_CODE_ACTIVATION_CONFIRMATION,
    ROUTE_MAIN,
    ROUTE_PASSWORD_CHANGE,
    ROUTE_PROFILE,
    ROUTE_PURCHASE
} from "../../App";
import LoginDataProvider from "../dataProviderEvo/login-data-provider";
import SubscriptionCodeActivateDataProvider from "../dataProviderEvo/subscription-code-activate-data-provider";


const CodeActivation = () => {

    const toast = useToast();

    const {isLoggedIn, userData, setUserId, setAuthToken, authToken} = useEvoContext();

    const [formData, setFormData] = useState(emptyFormDataCodeActivation);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [errors, setErrors] = useState({});

    const formRef = useRef(null);
    const timeoutRef = useRef(null);
    const nameRef = useRef(null);
    const phoneRef = useRef(null);

    const [showEmail, setShowEmail] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showContactFields, setShowContactFields] = useState(false);
    const [isReadOnlyCode, setIsReadOnlyCode] = useState(false);
    const [isReadOnlyEmail, setIsReadOnlyEmail] = useState(false);
    const [isReadOnlyPassword, setIsReadOnlyPassword] = useState(false);


    const [localidUser, setLocalIdUser] = useState(null);
    const [localAuthToken, setLocalAuthToken] = useState(null);

    const navigate = useNavigate();
    const backgroundSize = useBreakpointValue({ base: "20%", md: "contain", sm: "cover"});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const validateForm = () => {


        const form = formRef.current;
        if (form) {

            const currentFormData = getFormValues(form);

            currentFormData.paymentType = PAYMENT_CODE; // pro obecnou validaci kodu

            const additionalRules = {
                password: {
                    customDisabled: true,
                },
            };


            const { isValid, validationErrors} = formValidator(currentFormData, fieldNameAndLabels, additionalRules);

            setErrors(validationErrors);

            if (isValid) {
                return true;
            }
        }
        return false;
    };




    const handleSubmit = (e) => {

        e.preventDefault(); // Prevent the default form submission
        if(validateForm(formRef.current)){

            /*let headers = {
                "Auth-login-name": formData.email,
                "Auth-login-password-b64": btoa(value)
            }*/


            toast.closeAll();
            let headers = {};
            let params = {};

            if(isLoggedIn && authToken){
               headers = {
                    "email": formData.email,
                    "Auth-token": authToken
               }

                params = {
                    "email": formData.email,
                    "name": formData.name,
                    "surname": formData.surname,
                    "telephone": formData.telephone
                }

            } else if (showPassword){
                headers = {
                    "Auth-login-name": formData.email,
                    "Auth-login-password-b64": btoa(formData.password)
                }

                params = {
                    "email": formData.email,
                    "name": formData.name,
                    "surname": formData.surname,
                    "telephone": formData.telephone
                }

            } else {
                params = /*headers =*/ {
                    "email": formData.email,
                    "name": formData.name,
                    "surname": formData.surname,
                    "telephone": formData.telephone
                }

            }

            // let params = {};
            // if(isLoggedIn && authToken){
            //     headers = {
            //         "email": formData.email,
            //         "Auth-token": authToken,
            //         "name": formData.name,
            //         "telephone": formData.telephone
            //     }
            // } else {
            //     params = headers = {
            //         "email": formData.email,
            //         "name": formData.name,
            //         "telephone": formData.telephone
            //     }
            // }

            let dp = new SubscriptionCodeActivateDataProvider();
            dp.getData(formData.subscriptionActivationCode, params, headers).then((res) => {

                if (res && res.status === 'OK') {

                    let text = '',
                        title = '',
                        route = ROUTE_MAIN;

                    if(isLoggedIn || (localAuthToken && localidUser)){

                        setUserId(localidUser);
                        setAuthToken(localAuthToken);

                        route += ROUTE_CODE_ACTIVATION_CONFIRMATION;
                        title = 'Úspěšná aktivace předplatného!';
                        text = 'Vaše předplatné bylo úspěšně aktivováno. Děkujeme, že jste s námi. Nyní máte plný přístup k veškerému obsahu. Užijte si čtení.';
                    } else {

                        route += ROUTE_CODE_ACTIVATION_CONFIRMATION;

                        title = 'Formulář úspěšně odeslán!';
                        text = '';
                        // text = 'Vaše údaje byly úspěšně odeslány. Během chvíle obdržíte e-mail s dalšími pokyny. Děkujeme!';
                    }

                    toast({
                        title: title,
                        description: text,
                        status: 'success',
                        duration: 5000,
                        isClosable: true,
                        position: "top"
                    });

                    navigate(route);

                } else {
                    toast({
                        title: 'Chyba při aktivaci předplatného',
                        description: res.errors[0] + " Zkuste to prosím znovu, nebo nás kontaktujte, pokud problém přetrvává.",
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                        position: "top"
                    });

                }
            });
        }
    };


    const handleChangeCode = (e) => {
        const { name, value } = e.target;

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {

            if(value) {

                toast.closeAll();

                let dp = new SubscriptionCodeValidateDataProvider();
                dp.getData(value, {}).then((res) => {

                    if (res && res.status === 'OK') {

                        setIsReadOnlyCode(true);

                        if(!isLoggedIn){

                            setShowEmail(true);

                            toast({
                                title: 'Aktivace předplatného',
                                description: 'Prosíme, vyplňte e-mailovou adresu.',
                                status: 'success',
                                duration: 5000,
                                isClosable: true,
                                position: "top"
                            });
                        }

                    } else {

                        setIsReadOnlyCode(false);

                        toast({
                            title: 'Upozornění',
                            description: res.errors[0],
                            status: 'info',
                            duration: 5000,
                            isClosable: true,
                            position: "top"
                        });
                    }
                });
            }

        }, 700);

        handleChange(e);
    };


    const handleChangeEmail = (e) => {
        const { name, value } = e.target;

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            if(value) {
                setShowContactFields(false);

                const { isValid, validationErrors} = formValidator({ "email": value}, fieldNameAndLabels);

                toast.closeAll();

                if(isValid){
                    let dp = new UserEmailCheckDataProvider();
                    dp.getData(value, {}).then((res) => {

                        if (res && res.status === 'OK') {

                            setShowPassword(false);
                            setShowContactFields(true);

                            // toast({
                            //     title: 'Aktivace předplatného',
                            //     description: 'Prosíme, přidejte Kontaktní údaje.',
                            //     status: 'success',
                            //     duration: 5000,
                            //     isClosable: true,
                            // });

                        } else {

                            // setIsReadOnlyEmail(true);
                            setShowPassword(true);

                            toast({
                                title: 'Upozornění ',
                                description: res.errors[0],
                                status: 'info',
                                duration: 5000,
                                isClosable: true,
                                position: "top"
                            });
                        }
                    });
                    } else {
                        setShowPassword(false);
                    }
                }

        }, 700);

        handleChange(e);
    };


    const handleChangePassword = (e) => {
        const { name, value } = e.target;



        // if(value != '' && value!= undefined && value.length > 0){
        //     setShowContactFields(true);
        // }

        //
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {

            if(value) {

                toast.closeAll();

                let headers = {
                    "Auth-login-name": formData.email,
                    "Auth-login-password-b64": btoa(value)
                }

                let dp = new LoginDataProvider();
                dp.login({}, headers).then((res) => {

                    if (res.status === 'OK') {
                        // if (res.status === dp.STATUS_OK) {
                        // setIsReadOnlyEmail(true)
                        // setIsReadOnlyPassword(true);
                        setShowContactFields(true);


                        setLocalIdUser(res.data.user_id);
                        setLocalAuthToken(res.data.token);

                        // setUserId(res.data.user_id);
                        // setAuthToken(res.data.token);

                        // toast({
                        //     title: 'Úspěch',
                        //     description: 'Přihlášení proběhlo úspěšně',
                        //     status: 'success',
                        //     duration: 5000,
                        //     isClosable: true,
                        // });

                    } else {

                        setShowContactFields(false);
                        setLocalIdUser(null);
                        setLocalAuthToken(null);

                        toast({
                            title: 'Ověření hesla se nezdařilo',
                            description: res.errors[0] || 'Zkuste akci zopakovat.',
                            status: 'error',
                            duration: 5000,
                            isClosable: true,
                            position: "top"
                        });
                    }
                });
            }

        }, 700);

        handleChange(e);
    };

    useEffect(() => {

       if(Object.keys(userData).length > 0){

           if (nameRef.current) {
               const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
                   window.HTMLInputElement.prototype,
                   'value'
               ).set;

               nativeInputValueSetter.call(nameRef.current, userData.name);

               const event = new Event('input', { bubbles: true });
               nameRef.current.dispatchEvent(event);
           }
       }

       if(!isLoggedIn){
           setIsReadOnlyCode(false);
       }


    }, [isLoggedIn, userData]);



    useEffect(() => {

        toast.closeAll();

        if (Object.keys(errors).length > 0) {

            const errorList = Object.values(errors).map((error, index) => (
                <li key={index}>{error}</li>
            ));

            // const errorMessage = Object.values(errors).join('\n');
            toast({
                title: 'Prosíme vyplňte povinné údaje',
                description: (
                    <Box as="ul" ml={4}>
                        {errorList}
                    </Box>
                ),
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: "top"
            });
        }

    }, [errors/*, showEmail, showPassword, showContactFields*/]);

    // useEffect(() => {
    //
    //     const keys = Object.keys(userData); // ['id', 'name', 'email', 'age', 'isActive', 'address']
    //     const values = Object.values(userData);
    //
    //     if(keys.length > 0){
    //
    //         {keys.map((value, index) => (
    //             setFormData((prevData) => ({
    //                 ...prevData,
    //                 [keys[index]]: values[index],
    //             }))
    //         ))}
    //     } else {
    //         setFormData(emptyFormData);
    //     }
    //
    //
    //
    // }, [userData]);

    return (
        <Box
            bg={useColorModeValue("#f9f9f9", "#1a202c")}
            // minHeight="100vh"
            justifyContent="center"
            alignItems="center"
            backgroundImage="url('./images/isues.png')"
            backgroundSize={backgroundSize}
            backgroundPosition="right"
            backgroundRepeat="no-repeat"
        >
            <Nav />
            <Container mb={"180px"} maxW={'2xl'} background={"rgba(249, 249, 249, 0.8)"}>
                <chakra.h1 textAlign={"center"} fontSize={"4xl"} py={10} fontWeight={"bold"}>
                    Aktivace online Vinařského obzoru
                </chakra.h1>

                {isLoggedIn && !showEmail && (<List py={3} spacing={3}>
                    {["Najděte svůj aktivační klíč, který je vytištěn v únorovém vydání Vinařského obzoru.",
                        "Zadejte klíč do níže uvedeného pole.",
                        "Klikněte na tlačítko \"Aktivovat\" a okamžitě získáte přístup k digitálnímu obsahu."]
                        .map((text, index) => (
                            <ListItem fontSize={"lg"} py={3} key={index}>
                                <HStack>
                                    <Circle size="40px" bg="gray.200" color="black" fontWeight={"bold"}>
                                        {index + 1}
                                    </Circle>
                                    <Text px={3}>{text}</Text>
                                </HStack>
                            </ListItem>
                        ))}
                </List>)}

                {!isLoggedIn && (<List py={3} spacing={3}>
                    {["Najděte svůj aktivační klíč, který je vytištěn v únorovém vydání Vinařského obzoru.",
                        "Zadejte klíč do níže uvedeného pole.",
                        "Zadajte e-mailovou adresu.",
                        "Klikněte na tlačítko \"Aktivovat\"."]
                        .map((text, index) => (
                            <ListItem fontSize={"lg"} py={3} key={index}>
                                <HStack>
                                    <Circle size="40px" bg="gray.200" color="black" fontWeight={"bold"}>
                                        {index + 1}
                                    </Circle>
                                    <Text px={3}>{text}</Text>
                                </HStack>
                            </ListItem>
                        ))}
                </List>)}

                {formSubmitted ? (
                <Box
                    bg="white"
                    p={8}
                    borderRadius="lg"
                    textAlign="center"
                >
                    <chakra.h1 fontSize="2xl" fontWeight="bold" mb={4}>
                        Formulář byl úspěšně odeslán!
                    </chakra.h1>
                    <Button colorScheme="pink" onClick={() => navigate('/')}>
                        Zpět
                    </Button>
                </Box>
            ) : (
                <>
            <Box
                width="100%"
                // maxW="600px"
                mx="auto"
                bg="white"
                borderRadius="lg"
                padding={10}
                boxShadow="md"
            >
                <form ref={formRef} onSubmit={handleSubmit}>
                    <VStack spacing={4} align="stretch">
                        <FormControl isInvalid={errors.subscriptionActivationCode}>
                            {/*<FormLabel>Kod</FormLabel>*/}
                            <FormLabelEvo mandatory={true}>{fieldNameAndLabels.subscriptionActivationCode.label}</FormLabelEvo>
                            <Input
                                type="text"
                                name={fieldNameAndLabels.subscriptionActivationCode.name}
                                value={formData.subscriptionActivationCode}
                                isReadOnly={isReadOnlyCode}
                                // onChange={handleChangeCode}
                                onInput={handleChangeCode}
                            />
                            <FormErrorMessage>{errors.subscriptionActivationCode}</FormErrorMessage>
                        </FormControl>

                        {showEmail && (<FormControl isInvalid={errors.email}>
                            <FormLabelEvo mandatory={true}>{fieldNameAndLabels.email.label}</FormLabelEvo>
                            <Input
                                type="email"
                                name={fieldNameAndLabels.email.name}
                                value={formData.email}
                                isReadOnly={isReadOnlyEmail}
                                onInput={handleChangeEmail}
                                // onChange={handleChangeEmail}
                            />
                            <FormErrorMessage>{errors.email}</FormErrorMessage>
                        </FormControl>)}

                        {showPassword && (<FormControlEvo>
                            <FormLabel>
                                Heslo
                            </FormLabel>
                            <Input defaultValue={formData.password} isReadOnly={isReadOnlyPassword} type={"password"} name={fieldNameAndLabels.password.name}  isInvalid={!!errors.password} onInput={handleChangePassword} />
                            {!isReadOnlyPassword && (<FormControlEvo>
                                <FormHelperText>
                                    <Link fontWeight={"semibold"} fontSize="md" href={ROUTE_PASSWORD_CHANGE} color="blue.500">
                                        Obnovení hesla
                                    </Link>
                                </FormHelperText>
                            </FormControlEvo>)}
                        </FormControlEvo>)}

                        {showContactFields  && (
                            <>
                            <FormLabelEvo isInvalid={errors.name}>
                                    <FormLabelEvo mandatory={true}>{fieldNameAndLabels.name.label}</FormLabelEvo>
                                    <Input
                                        ref={nameRef}
                                        type="text"
                                        name={fieldNameAndLabels.name.name}
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                    <FormErrorMessage>{errors.name}</FormErrorMessage>
                            </FormLabelEvo>

                                <FormControlEvo>
                                    <FormLabelEvo mandatory={true}>{fieldNameAndLabels.surname.label}</FormLabelEvo>
                                    <Input  defaultValue={formData.surname} type={"text"} name={fieldNameAndLabels.surname.name} onInput={handleChange} />
                                    <FormErrorMessage>{errors.surname}</FormErrorMessage>
                                </FormControlEvo>


                                <FormControl isInvalid={errors.telephone}>
                            <FormLabelEvo mandatory={true}>{fieldNameAndLabels.telephone.label}</FormLabelEvo>
                            <Input
                                ref={phoneRef}
                                type="tel"
                                name={fieldNameAndLabels.telephone.name}
                                value={formData.telephone}
                                onChange={handleChange}
                            />
                            <FormErrorMessage>{errors.telephone}</FormErrorMessage>
                        </FormControl>

                            </>)}

                        <Button mt={6} width="full" colorScheme="pink" type="submit">
                            Aktivovat
                        </Button>
                    </VStack>
                </form>
            </Box>
                </>
            )}
            </Container>

            <Footer />
        </Box>

    );
};

export default CodeActivation;
